import React, { useState, useEffect } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TablePagination from '@mui/material/TablePagination'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import { useAuth } from "./api/authStore"
import moment from 'moment'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import Button from '@mui/material/Button'
import ConfirmDialog from './ConfirmDialog'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

const useStyles = makeStyles((theme) => ({
    main: {
        width: '80%',
        height: '100vh',
    },
    header: {
        // height: '72px',
        margin: '32px',
        fontWeight: 600,
    },
    content: {
        height: '72px',
        marginLeft: '18px',
        // marginRight: '32px',
    },
    tableDiv: {
        marginTop: '16px',
    },
    tableDataCell: {
        height: '20px',
        paddingTop: '15px',
    },
    dateDiv: {
      columnCount: 2,
      width: '420px'
    },
    emptyContent: {
      height: '72px',
      marginLeft: '18px',
      marginRight: '32px',
      height: '400px',
      border: '1px solid',
      borderRadius: '16px',
      justifyContent: 'center',
      textAlign:'center',
      paddingTop: '200px',
      marginTop: '32px'
    },
}))

function TablePaginationActions(props) {
    const theme = useTheme()
    
    const { count, page, rowsPerPage, onPageChange } = props
  
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }
  
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
         <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
            <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
        </IconButton>
      </Box>
    )
  }

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }

const HistoryTable = (props) => {
    const { user, getAccessTokenSilently, setToken, logout } = useAuth()
    
    const classes = useStyles()

    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [historyList, setHistoyrList] = React.useState([])
    const [startDate, setStartDate] = React.useState(dayjs())
    const [endDate, setEndDate] = React.useState(dayjs().endOf('month'))

    //history purchase
    const [confirmOpen, setConfirmOpen] = React.useState(false)
    const [selectedRow, setSelectedRow] = useState([])
    const [afterBuy, setAfterBuy] = React.useState(false)
    const [errorGetAgentInfo, setErrorGetAgentInfo] = useState(false)

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - historyList?.items?.length) : 0

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    useEffect(()=>{
      const callAsync = async() => {
          try {
            const dateStartFormated = startDate.format('YYYY-MM-DD 00:00:00')
            const dateEndFormated = endDate.format('YYYY-MM-DD 23:59:59')
            const historyPesponse = await props.apiClient.setToken(getAccessTokenSilently()).getUserHistory(dateStartFormated, dateEndFormated, page, rowsPerPage)
            // console.log(historyPesponse.items)
            setHistoyrList(historyPesponse)
          } catch (e) {
              // console.log(e)
          }
          
      }
      callAsync()   
    },[startDate, endDate, page, rowsPerPage])

    const handleSetStartDate = (date) => {
      setStartDate(date)
    }

    const handleSetEndDate = (date) => {
      setEndDate(date)
    }

    const handleButtonClick = async(row) => {
       try {
          const agentData = await props.apiClient.setToken(getAccessTokenSilently()).getAgentInfo(row?.agentID)
          if(agentData?.id == null || agentData?.id == undefined){
              throw 'error'
          }

          setSelectedRow(agentData)
          setConfirmOpen(true)
          // console.log(agentData)
       } catch(e){
          setErrorGetAgentInfo(true)
       }
    }

    const handleCloseGetAgentInfoError = () => {
      setErrorGetAgentInfo(false)
    }

    return (
      
        <div className={classes.main}>
            <div className={classes.header}>History</div>
            <div className={classes.dateDiv}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']} sx={{marginLeft: '18px', width: '200px'}}>
                  <DatePicker label="From" value={startDate} onChange={(newValue) => handleSetStartDate(newValue)}/>
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']} sx={{marginLeft: '18px', width: '200px'}}>
                  <DatePicker label="To" value={endDate} onChange={(newValue) => handleSetEndDate(newValue)}/>
                </DemoContainer>
              </LocalizationProvider>
            </div>
            {historyList?.items?.length>0 ? (
             <div className={classes.content}>
                <div className={classes.tableDiv}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer component={Paper} sx={{ maxHeight: 550 }}>
                        <Table stickyHeader sx={{borderColor: '#B6BABF'}}>
                            <TableHead>
                            <TableRow>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>IP</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>Country</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>State</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>City</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>Zip</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>ISP</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}>Date</TableCell>
                                <TableCell align="left" sx={{ borderBottom: "none" }}></TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {historyList?.items?.map((row) => (
                                <TableRow hover>
                                    <TableCell align="left" sx={{ borderBottom: "none"}}>{row?.ip}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{row?.loc?.cc}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{row?.loc?.reg}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{row?.loc?.city}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{row?.loc?.zip}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{row?.loc?.isp?.replace(/(.{10})..+/, "$1…")}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none" }}>{moment(row.paidUntil).format('MMM-D LT')}</TableCell>
                                    <TableCell align="left" sx={{ borderBottom: "none"}}>
                                      <Button onClick={()=>{handleButtonClick(row)}}>Buy</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div>
                        <TablePagination
                                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                                        colSpan={3}
                                        count={historyList?.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        slotProps={{
                                            select: {
                                            inputProps: {
                                                'aria-label': 'rows per page',
                                            },
                                            native: true,
                                            },
                                        }}
                                        ActionsComponent={TablePaginationActions}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                    </div>

                </Paper>
                <ConfirmDialog open={confirmOpen} setConfirmOpen={setConfirmOpen} selectedProxy={selectedRow} apiClient={props.apiClient} setAfterBuy={setAfterBuy}/>
                <Snackbar
                  open={errorGetAgentInfo}
                  autoHideDuration={6000}
                  onClose={handleCloseGetAgentInfoError}
                  anchorOrigin={{vertical: 'top', horizontal: 'center' }} >
                    <Alert
                        severity="warning"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >Couldn't get proxy info. Please try again later.</Alert>
                </Snackbar>
                </div>
            </div>
             ):(
              <div className={classes.emptyContent}><span>You don't have any records</span></div>
            )}
        </div>
       
    )
}

export default HistoryTable